/*
 * Copyright © 2015-2018 Serenova, LLC. All rights reserved.
 */

import { createSelector } from 'reselect';
import  faviconImage  from '../../../../assets/favicons/favicon-16x16.png';
import  logoImage  from '../../../../assets/icons/cxengage_white.png';


const getBranding = state => state && state.getIn(['Entities', 'branding', 'data']);

export const getProtectedBranding = state => state.getIn(['Entities', 'protectedBranding', 'data']);

export const hasAllBranding = state => getBranding(state) !== undefined && getProtectedBranding(state) !== undefined;

const getStyles = state => (getBranding(state) && getBranding(state).get('styles')) || '{}';

export const getCustomTheme = createSelector([getStyles], styles => JSON.parse(styles));

export const isBrandingUpdating = state => state.getIn(['Entities', 'branding', 'isUpdating']);

const getlogo = state => (getBranding(state) && getBranding(state).get('logo')) || logoImage;

export const getCustomlogo = createSelector([getlogo], logo => logo);


const getFavicon = state => (getBranding(state) && getBranding(state).get('favicon')) || faviconImage; 

export const getCustomFavicon = createSelector([getFavicon], favicon => favicon);
